"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  create: function create(styles) {
    return styles;
  },

  flattenStyle: function flattenStyle(style, processor) {
    if (!style) {
      return undefined;
    }

    if (!Array.isArray(style)) {
      return processor && processor(style) || style;
    }
    var result = {};
    for (var i = 0; i < style.length; ++i) {
      var computedStyle = flattenStyle(style[i]);
      if (computedStyle) {
        for (var key in computedStyle) {
          if (computedStyle.hasOwnProperty(key)) {
            result[key] = computedStyle[key];
          }
        }
      }
    }

    return processor && processor(result) || result;
  }
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rmc-list-view/lib/StyleSheet.js
 ** module id = 436
 ** module chunks = 0
 **/